export const SettingsNavigation = {
  PATH: 'settings',
  searchParamKey: 'tab',
};
